import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
} from '@angular/material';
import { downgradeComponent } from '@angular/upgrade/static';
import { MaskModule } from '@mandae/ng-utils/mask';
import { MdePopoverModule } from '@material-extended/mde';
import * as angular from 'angular';
import { TextMaskModule } from 'angular2-text-mask';
import { DashboardModule } from '../../dashboard/dashboard.module';
import { FormsComponentsModule } from '../../forms/components/forms-components.module';
import { ServicesModule } from '../../services/services.module';
import { ShippingReturnRoutingModule } from '../../shipping-return/shipping-return-routing.module';
import { AddressDefaultDialogComponent } from './address-default-dialog/address-default-dialog.component';
import { AddressFormComponent } from './address-form/address-form.component';
import { AddressListComponent } from './address-list/address-list.component';
import { AddressRemoveDialogComponent } from './address-remove-dialog/address-remove-dialog.component';

@NgModule({
  declarations: [
    AddressListComponent,
    AddressFormComponent,
    AddressRemoveDialogComponent,
    AddressDefaultDialogComponent,
  ],
  entryComponents: [
    AddressRemoveDialogComponent,
    AddressDefaultDialogComponent,
    AddressFormComponent,
  ],
  imports: [
    ShippingReturnRoutingModule,
    ServicesModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MdePopoverModule,
    DashboardModule,
    FlexLayoutModule,
    FormsModule,
    FormsComponentsModule,
    MaskModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TextMaskModule,
  ],
  exports: [
    AddressListComponent,
    AddressFormComponent,
  ],
})
export class AddressModule { }

try {
  angular.module('mandaeApp')
    .directive('appProfileAddress', downgradeComponent({ component: AddressListComponent }));
} catch (e) {}
